'use strict';
var toIntegerOrInfinity = require('../internals/to-integer-or-Infinity');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toObject = require('../internals/to-object');

/**
 * Array.prototype.at
 * 暂未实现Array.prototype[@@unscopables]：详细可看https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/@@unscopables
 */
module.exports = {
  target: Array,
  property: 'at',
  proto: true,
  handler: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
  },
};
